import { BehaviorSubject } from "rxjs";
import { EventEmitter } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { IFilter } from "../services/IFilter";
import { AuthService } from "../services/auth.service";

export class CmdbMountPointsFilter implements IFilter {
  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor(private auth: AuthService) {
    this.clear();
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(value:any) {
    this.companyIdChange.next(value);
    this.emitChange("companyId", value);
  }

  osTypeNameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get osTypeName():any {
    return this.osTypeNameChange.value;
  }
  set osTypeName(value:any) {
    this.osTypeNameChange.next(value);
    this.emitChange("osTypeName", value);
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(value:any) {
    this.nameChange.next(value);
    this.emitChange("name", value);
  }

  purposeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get purpose():any {
    return this.purposeChange.value;
  }
  set purpose(value:any) {
    this.purposeChange.next(value);
    this.emitChange("purpose", value);
  }

  descriptionChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get description():any {
    return this.descriptionChange.value;
  }
  set description(value:any) {
    this.descriptionChange.next(value);
    this.emitChange("description", value);
  }

  statusNameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get statusName():any {
    return this.statusNameChange.value;
  }
  set statusName(value:any) {
    this.statusNameChange.next(value);
    this.emitChange("statusName", value);
  }

  typeNameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get typeName():any {
    return this.typeNameChange.value;
  }
  set typeName(value:any) {
    this.typeNameChange.next(value);
    this.emitChange("typeName", value);
  }

  fileSystemNameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get fileSystemName():any {
    return this.fileSystemNameChange.value;
  }
  set fileSystemName(value:any) {
    this.fileSystemNameChange.next(value);
    this.emitChange("fileSystemName", value);
  }

  minSizeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get minSize():any {
    return this.minSizeChange.value;
  }
  set minSize(value:any) {
    this.minSizeChange.next(value);
    this.emitChange("minSize", value);
  }

  maxSizeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get maxSize():any {
    return this.maxSizeChange.value;
  }
  set maxSize(value:any) {
    this.maxSizeChange.next(value);
    this.emitChange("maxSize", value);
  }

  seperateDiskChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get seperateDisk():any {
    return this.seperateDiskChange.value;
  }
  set seperateDisk(value:any) {
    this.seperateDiskChange.next(value);
    this.emitChange("seperateDisk", value);
  }

  activeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get active():any {
    return this.activeChange.value;
  }
  set active(value:any) {
    this.activeChange.next(value);
    this.emitChange("active", value);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }
    if (this.osTypeName && this.osTypeName !== '') {
      params = params.set("osTypeName", this.osTypeName);
    }
    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }
    if (this.purpose && this.purpose !== '') {
      params = params.set("purpose", this.purpose);
    }
    if (this.statusName && this.statusName !== '') {
      params = params.set("statusName", this.statusName);
    }
    if (this.typeName && this.typeName !== '') {
      params = params.set("typeName", this.typeName);
    }
    if (this.fileSystemName && this.fileSystemName !== '') {
      params = params.set("fileSystemName", this.fileSystemName);
    }
    if (this.minSize && this.minSize !== '') {
      params = params.set("minSize", this.minSize);
    }
    if (this.maxSize && this.maxSize !== '') {
      params = params.set("maxSize", this.maxSize);
    }
    if (this.seperateDisk && this.seperateDisk !== '') {
      params = params.set("seperateDisk", this.seperateDisk);
    }
    if (this.description && this.description !== '') {
      params = params.set("description", this.description);
    }
    if (this.active && this.active !== '') {
      params = params.set("active", this.active);
    }

    return params;
  }

  setFilters(props: any): void {
    this.companyIdChange.next(props.companyId === undefined ? this.auth.getCompanyId() : props.companyId || undefined);
    this.osTypeNameChange.next(props.osTypeName || undefined);
    this.nameChange.next(props.name || undefined);
    this.purposeChange.next(props.purpose || undefined);
    this.statusNameChange.next(props.statusName || undefined);
    this.typeNameChange.next(props.typeName || undefined);
    this.fileSystemNameChange.next(props.fileSystemName || undefined);
    this.minSizeChange.next(props.minSize || undefined);
    this.maxSizeChange.next(props.maxSize || undefined);
    this.seperateDiskChange.next(props.seperateDisk || undefined);
    this.descriptionChange.next(props.description || undefined);
    this.activeChange.next(props.active || undefined);
  }

  toObj() {
    let obj:any = {};

    obj.companyId = this.companyId;
    obj.osTypeName = this.osTypeName;
    obj.name = this.name;
    obj.purpose = this.purpose;
    obj.statusName = this.statusName;
    obj.typeName = this.typeName;
    obj.fileSystemName = this.fileSystemName;
    obj.minSize = this.minSize;
    obj.maxSize = this.maxSize;
    obj.seperateDisk = this.seperateDisk;
    obj.description = this.description;
    obj.active = this.active;

    return obj;
  }

  public clear():void {
    this.companyId = this.auth.getCompanyId();
    this.osTypeName = undefined;
    this.name = undefined;
    this.purpose = undefined;
    this.statusName = undefined;
    this.typeName = undefined;
    this.fileSystemName = undefined;
    this.minSize = undefined;
    this.maxSize = undefined;
    this.seperateDisk = undefined;
    this.description = undefined;
    this.active = undefined;
  }
}
